import { IBlock } from '@bees-web/core/types'
import { DeferredURL } from '../../types/interfaces'

export default function getDeferredUrl(
  block: IBlock,
  removeWaitForState = false
): DeferredURL | null {
  const { deferred, waitForState = [] } = block
  const shouldProcess = removeWaitForState ? waitForState.length === 0 : true

  if (deferred && shouldProcess) {
    if (typeof deferred === 'string')
      return {
        url: deferred,
        method: 'get'
      }

    const { url, method = 'get', headers = null } = deferred
    return {
      url,
      headers,
      method: method.toLowerCase()
    }
  }

  return null
}
